<template>
  <el-dialog
    :title="model.id ? '编辑商品' : '新增商品'"
    :visible.sync="visible"
    width="1000px"
    @close="$emit('update:show', false)"
    :close-on-click-modal="false"
    top="5vh"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="80px"
      size="small"
      class="long"
    >
      <el-row :gutter="40">
        <el-col :span="11">
          <el-form-item label="封面">
            <el-upload
              :action="uploadUrl"
              accept="image/*"
              :headers="uploadHeader"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :on-error="handleUploadError"
              :before-upload="beforeAvatarUpload"
              style="display: flex"
            >
              <auth-img
                tag="el-image"
                style="width: 60px; height: 60px"
                :src="model.cover"
                fit="cover"
                v-if="model.cover"
                ><div slot="error" class="image-slot">暂无图片</div></auth-img
              >
              <span v-else class="font-12">点击上传</span>
            </el-upload>
          </el-form-item>
          <!-- <el-form-item label="名称" prop="name">
        <el-input v-model="model.name"></el-input>
      </el-form-item> -->
          <el-form-item label="件号" prop="part_number">
            <el-input v-model="model.part_number"></el-input>
          </el-form-item>
          <el-form-item label="替代件号" prop="new_part_number">
            <el-input v-model="model.new_part_number"></el-input>
          </el-form-item>
          <el-form-item label="分类" prop="commodity_category_id">
            <category-select
              @change="model.commodity_category_id = $event"
              :val="model.commodity_category_id"
              :departmentID="model.department_id"
            ></category-select>
          </el-form-item>
          <el-form-item label="PH" prop="ph">
            <!-- <el-input v-model="model.ph" style="width: 220px"></el-input> -->
            <el-autocomplete
              style="width: 100%"
              v-model="model.ph"
              :fetch-suggestions="queryPHSearch"
              placeholder="请输入PH"
            ></el-autocomplete>
          </el-form-item>
          <el-form-item label="PH描述" prop="ph_desc">
            <el-input
              type="textarea"
              style="width: 100%"
              v-model="model.ph_desc"
              placeholder="请输入PH描述"
              maxlength="100"
            ></el-input>
          </el-form-item>
          <el-form-item label="类型" prop="type">
            <el-select v-model="model.type">
              <el-option label="备件" key="1" :value="1"></el-option>
              <el-option label="服务" key="2" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产地" prop="origin_place">
            <el-select v-model="model.origin_place">
              <el-option label="国产" key="1" :value="1"></el-option>
              <el-option label="进口" key="2" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="下单审批" prop="whether_approve">
            <el-select v-model="model.whether_approve">
              <el-option label="否" key="1" :value="1"></el-option>
              <el-option label="是" key="2" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="EC审批" prop="ec_approve">
            <el-select v-model="model.ec_approve">
              <el-option label="否" key="1" :value="1"></el-option>
              <el-option label="是" key="2" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="单价" prop="price">
            <el-input-number
              v-model="model.price"
              :precision="2"
              :step="0.1"
              :max="10000000"
            ></el-input-number>
          </el-form-item>

          <el-form-item label="等级价" v-if="model.department_id != 1">
            <div
              class="mb-5 rank-price"
              v-for="(k, v) in DealerRanks"
              v-if="parseInt(v) > 0"
            >
              <div class="label mr-10">{{ k.slice(0, 2) }}</div>
              <el-input-number
                v-model="model.rank_price[parseInt(v) - 1]"
                :precision="2"
                :step="0.1"
                :max="10000000"
              ></el-input-number>
              <span class="ml-5" v-if="model.price > 0"
                >{{
                  (
                    (model.rank_price[parseInt(v) - 1] / model.price) *
                    100
                  ).toFixed(0)
                }}%</span
              >
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="13">
          <el-form-item label="" label-width="0" prop="description">
            <div class="mb-10 line-height-1">英文描述</div>
            <el-input type="textarea" v-model="model.description"></el-input>
          </el-form-item>
          <el-form-item label="" label-width="0" prop="description_zh">
            <div class="mb-10 line-height-1">中文描述</div>
            <el-input type="textarea" v-model="model.description_zh"></el-input>
          </el-form-item>
          <el-form-item label="" label-width="0">
            <div class="mb-10 line-height-1">
              商品详情<span class="font-12 text-info ml-5"
                >（为呈现最佳的显示效果，请尽量用图片形式呈现）</span
              >
            </div>
            <RichEditor
              class="editor mobile"
              v-model="model.content"
            ></RichEditor>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { createCommodity, updateCommodity } from '@/service/getData'
import { urlPerfix } from '@/config/env'
import store from '@/store/store'
import CategorySelect from '@/components/select/commodity_category_select'
import { DealerRanks, CommodityPhs } from '@/config/global.js'
import RichEditor from '@/components/rich-editor'

export default {
  components: {
    CategorySelect,
    RichEditor,
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      DealerRanks,
      uploadUrl: urlPerfix + '/files/upload',
      uploadHeader: { Token: store.state.userInfo.token },

      visible: this.show,
      rules: {
        name: [{ required: true, message: '请填写商品名称' }],
        part_number: [{ required: true, message: '请填写件号' }],
        commodity_category_id: [{ required: true, message: '请选择分类' }],
        price: [{ required: true, message: '请填写单价' }],
        description: [{ required: true, message: '请填写英文描述' }],
      },
      phs: CommodityPhs,
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.model.id > 0) {
            let res = await updateCommodity(this.model)
            if (res.code == 0) {
              this.visible = false
              this.$emit('updated', res.data)
            }
          } else {
            let res = await createCommodity(this.model)
            if (res.code == 0) {
              this.visible = false
              this.$emit('created', res.data)
            }
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    queryPHSearch(queryString, cb) {
      var restaurants = this.phs
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) > 0
        )
      }
    },
    handleAvatarSuccess(res, file) {
      if (res.code == 0) {
        this.model.cover = res.data
      }
    },
    handleUploadError(err) {
      this.$message({
        message: '上传失败，请重试',
        type: 'error',
        center: true,
      })
    },
    beforeAvatarUpload(file) {
      const isJPG = true
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
  },
}
</script>

<style scoped>
.rank-price {
  display: flex;
}

/deep/.ql-editor {
  min-height: 100px;
}

/deep/.ql-editor img {
  width: 100% !important;
}

/deep/.ql-formats {
  line-height: 0;
}

/deep/.long .el-select,
/deep/.long .el-input-number {
  width: 100% !important;
}
</style>